























































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {MixinMember} from '@/components/mixins/MixinMember'
import {Period} from '@/enums/Period'
import DeliverySatisfactionSurveyHistoryRequest from '@/model/request/DeliverySatisfactionSurveyHistoryRequest'
import {ItrackCollection} from '@/helpers'
import {IResource, ObjectCollection} from 'simpli-web-sdk'
import Motorista from '@/model/resource/Motorista'

@Component
export default class FilterDeliverySatisfactionSurveyHistory extends Mixins(MixinMember) {
  @Prop({required: true}) value!: DeliverySatisfactionSurveyHistoryRequest

  Period = Period
  allMotorista = ItrackCollection.allMotorista

  async mounted( ) {
    await this.allMotorista.query()
    await this.valueComputed.allCentroDeCusto.query()
  }

  cleanDocs() {
    this.valueComputed.cleanDocs()
  }

  allDocsEvent(item: IResource, cache: IResource[]) {
    this.valueComputed.populateAllDocs(cache)
  }

  get valueComputed() {
    return this.value
  }

  set valueComputed(val) {
    this.$emit('input', val)
  }

  get motoristaResource() {
    return this.allMotorista.get(this.value.idMotorista)
  }

  set motoristaResource(val: Motorista | null) {
    this.value.idMotorista = val && val.$id || null
  }

  formatSigla() {
    if (this.value.sigla) {
      this.value.sigla = this.value.sigla.toUpperCase()
    }
  }

}
